import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/seo-articles';

export default function ArticlesSection() {
  const allArticles = [
    {
      slug: '/artigo-cssbuyspreadsheet-guia-completo-2026',
      title: 'CSSBuySpreadsheet 2026 — Guia Completo para Comprar na China',
      category: 'Guia',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20editorial%20photography%20of%20a%20modern%20workspace%20with%20laptop%20displaying%20product%20catalog%20surrounded%20by%20fashion%20items%20on%20a%20warm%20cream%20desk%20soft%20natural%20lighting&width=600&height=400&seq=art-v2-main-guide&orientation=landscape',
    },
    ...seoArticles.map((a) => ({
      slug: `/artigo/${a.slug}`,
      title: a.title,
      category: a.category,
      image: a.image,
    })),
  ];

  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-12 md:mb-16">
          <div>
            <p className="text-sm font-semibold text-secondary-500 mb-3 tracking-wide uppercase">Conteúdo SEO</p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900">
              Artigos & <span className="text-primary-500">Guias</span>
            </h2>
            <p className="mt-2 text-foreground-500 text-sm">10 artigos completos para você dominar as compras na China</p>
          </div>
          <span className="hidden md:inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-foreground-900 text-background-50 text-xs font-semibold whitespace-nowrap">
            <i className="ri-fire-line"></i>
            MAIS LIDOS
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {allArticles.map((article, idx) => (
            <Link
              key={idx}
              to={article.slug}
              className="group block bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:ring-2 hover:ring-primary-200"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <span className="text-xs font-semibold text-primary-500 uppercase tracking-wide">
                  {article.category}
                </span>
                <h3 className="mt-2 text-sm font-bold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <p className="mt-3 text-xs font-medium text-foreground-500 flex items-center gap-1 group-hover:gap-2 transition-all">
                  Ler artigo
                  <i className="ri-arrow-right-line"></i>
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}